define('boxes/signup-account',['jquery', 'boxes/helpers/signUpValidation', 'boxes/events/signUpEvent', 'boxes/box', 'boxes/helpers/box-loading', 'boxes/helpers/middle-bar-helper', 'boxes/helpers/signup-render', 'all/comeon'], function ($, signUpValidation, signUpEvent, box, boxLoading, middleBarHelper, signupRenderHelper, comeon) {
    'use strict';

    var ENTER_KEY = 13,
        ERROR_CLASS = 'has-error',
        VALID_CLASS = 'is-valid',
        referAFriendName,
        referAFriendSurname;

    /*
     * Stores the user's temporary data into the DB to be analyzied, etc.
     */
    function storeUsersTemporaryData(signUpAccount) {
        var PARAM_USER_NAME = signUpAccount.$box.find('#signup-username').val(),
            PARAM_EMAIL = signUpAccount.$box.find('#signup-email').val(),
            PARAM_PASSWORD = signUpAccount.$box.find('#signup-password').val(),
            usersTemporaryData = {
                PARAM_USER_NAME: PARAM_USER_NAME,
                PARAM_EMAIL: PARAM_EMAIL,
                PARAM_PASSWORD: PARAM_PASSWORD
            };

        $.post('/pp?flow=SaveUsersTemporaryInfoAtRegistration', usersTemporaryData);
    }

    function showVoucherField($voucherLink) {
        $voucherLink.hide();
        $voucherLink.next().show();
    }

    function removeDelayFromIcons($controller) {
        $controller.find('.step').each(function () {
            $(this).find('.icon').removeClass('delay4 delay6 delay8 delay10');
        });
    }

    function next(signUpAccount, $form) {
        var $controller = signUpAccount.$controller,
            data = {};

        $form.serializeArray().map(function (input) {
            data[input.name] = input.value;
        });
        data.PARAM_FIRST_NAME = referAFriendName;
        data.PARAM_SURNAME = referAFriendSurname;
        removeDelayFromIcons($controller);
        $controller.trigger(signUpEvent.ACCOUNT_DATA, data);
        $controller.trigger(signUpEvent.SLIDE_ICON);
        $controller.nextBox();
    }

    function setupNextHandler(signUpAccount) {
        var $box = signUpAccount.$box;
        $box.find('.next').off('click').on('click', function (e) {
            e.preventDefault();

            var $form = $box.find('form');
            if (signUpValidation.isFormValidated($form)) {
                $(this).off();
                boxLoading.showLoading(signUpAccount.$box);
                next(signUpAccount, $form);
                storeUsersTemporaryData(signUpAccount);
            }
        });
    }

    function setupVoucherHandler(signUpAccount) {
        signUpAccount.$box.find('.sign-up-voucher-code').off('click').on('click', function (e) {
            e.preventDefault();
            showVoucherField($(this));
        });
    }

    function setupEnterHandler(signUpAccount) {
        var $form = signUpAccount.$box.find('form'),
            $repeatPassword = signUpAccount.$box.find('input[name=repeatPassword]');
        $repeatPassword.off('keypress').on('keypress', function (event) {
            if (event.which === ENTER_KEY) {
                if (signUpValidation.isFormValidated($form)) {
                    boxLoading.showLoading(signUpAccount.$box);
                    next(signUpAccount, $form);
                    $repeatPassword.blur();
                    storeUsersTemporaryData(signUpAccount);
                }
            }
        });
    }

    function resetFormFields($box) {
        $box.find('input').each(function () {
            $(this).val('');
            $(this).parent().addClass(VALID_CLASS).removeClass(ERROR_CLASS);
        });
        $box.find('span.s20-check').hide();
        $box.find('div').removeClass('has-autofill');
        $box.find('.sign-up-voucher-code').show().next().hide();
        $box.find('.popover').hide();
    }

    function getRaFAutoFill($box) {
		var hash = $(location).attr('hash');
        var ajaxReferAFriendPromise = comeon.promise.create();
		if(hash.indexOf('register') > -1){
			ajaxReferAFriendPromise.resolve();
		}
		else{
        	$.post('/pp?flow=ReferAFriendData')
            	.done(function (data) {
                	if (data.PARAM_USER_NAME !== undefined) {
                    	showVoucherField($box.find('.sign-up-voucher-code'));
                	}
                	$box.find('input[name=PARAM_BONUS_CODE]').val(data.PARAM_USER_NAME);
                	$box.find('input[name=PARAM_EMAIL]').val(data.PARAM_EMAIL);
                	referAFriendName = data.PARAM_FIRST_NAME;
                	referAFriendSurname = data.PARAM_SURNAME;
                	ajaxReferAFriendPromise.resolve();
            });
		}
        return ajaxReferAFriendPromise.promise();
    }

    function renderReturnedUnregisteredUsers(signUpAccount) {
        function setValue($inputElement, value) {
            if (value === '') {
                return;
            }
            $inputElement.val(value);
            signUpValidation.updateInputWithGreenTick($inputElement);
        }

        if (signUpAccount.model.unregisteredData.trackingRegistration) {
            var userInfo = signUpAccount.model.unregisteredData.tempUserInfo;
            setValue(signUpAccount.$box.find('input[name=PARAM_USR_NAME]'), userInfo.VALIDATED_USERNAME);
            setValue(signUpAccount.$box.find('input[name=PARAM_EMAIL]'), userInfo.VALIDATED_EMAIL);
            signUpAccount.model.unregisteredData.trackingRegistration = false;
        }

    }

    function validateTokenIdInSignup(signupAccount) {
        var ajaxValidateTokenIdInSignupPromise = comeon.promise.create(),
            tokenId = signupAccount.$controller.$controller.data('tokenId'),
            failingResponse = {
                trackingRegistration: false,
                tempUserInfo: undefined
            };

        if (signupAccount.$controller.$controller.data('tokenId') === undefined) {
            ajaxValidateTokenIdInSignupPromise.reject();
            return ajaxValidateTokenIdInSignupPromise.promise();
        }

        $.post('/pp?flow=ValidateTokenIdInRegistration', { tokenId: tokenId })
            .done(function (resultData) {
                if (resultData.STATUS !== 'ERROR') {
                    signupAccount.model.unregisteredData = {
                        trackingRegistration: true,
                        tempUserInfo: resultData
                    };
                } else {
                    signupAccount.model.unregisteredData = failingResponse;
                }
            }).fail(function () {
                signupAccount.model.unregisteredData = failingResponse;
            }).always(function () {
                ajaxValidateTokenIdInSignupPromise.resolve();
            });
        return ajaxValidateTokenIdInSignupPromise.promise();
    }

    var view = {
            render: function () {
            }
        },
        model = {
            unregisteredData: undefined,
            init: function () {
            },
            beforeRender: function (signUpAccount) {
				resetFormFields(signUpAccount.$box);
                var tokenInSignupPromise = validateTokenIdInSignup(signUpAccount),
                    ajaxRafPromise = getRaFAutoFill(signUpAccount.$box);
                return [tokenInSignupPromise, ajaxRafPromise];
            },
            afterRender: function (signUpAccount) {
                setupNextHandler(signUpAccount);
                setupEnterHandler(signUpAccount);
                setupVoucherHandler(signUpAccount);
                signUpValidation.setupValidation(signUpAccount);
				signupRenderHelper.setupTermsAndConditions(signUpAccount);
                middleBarHelper.show(signUpAccount, 'signup');
                renderReturnedUnregisteredUsers(signUpAccount);
            },
            close: function (signUpAccount) {
                middleBarHelper.hide(signUpAccount, 'signup');
            }
        };

    return {
        create: function ($box, $controller) {
            return box.create($box, $controller, view, model);
        }
    };
});

